export const common = {
  'site.name': 'CSSBuy Spreadsheet',
  'site.tagline': 'Produkte, Verkäufer und Guides an einem Ort finden',
  'nav.home': 'Startseite',
  'nav.categories': 'Kategorien',
  'nav.guides': 'Guides',
  'nav.shoppingGuide': 'Einkaufsführer',
  'nav.qc': 'QC Zentrum',
  'nav.shipping': 'Versand',
  'nav.reviews': 'Bewertungen',
  'nav.safety': 'Sicherheit',
  'nav.about': 'Über uns',
  'nav.contact': 'Kontakt',
  'lang.pt': 'Português',
  'lang.de': 'Deutsch',
  'lang.en': 'English',
  'cta.explore': 'CSSBuy Spreadsheet erkunden',
  'cta.visitMain': 'Hauptwebsite besuchen',
  'cta.buyNow': 'Jetzt kaufen',
  'cta.readMore': 'Mehr lesen',
  'cta.viewAll': 'Alle anzeigen',
  'cta.search': 'Suchen',
  'footer.disclaimer': 'Diese Website ist eine unabhängige Informationsquelle und nicht unbedingt mit CSSBuy verbunden.',
  'footer.copyright': '© 2026 CSSBuy Spreadsheet. Alle Rechte vorbehalten.',
  'footer.links': 'Links',
  'footer.resources': 'Ressourcen',
  'footer.legal': 'Rechtliches',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.editorial': 'Redaktionsrichtlinien',
  'footer.sitemap': 'Sitemap',
  'hero.title': 'CSSBuy Spreadsheet: Produkte, Verkäufer und Guides an einem Ort',
  'hero.subtitle': 'Erkunden Sie eine organisierte Sammlung von CSSBuy Spreadsheets, Produkten, Verkäufern, Kategorien und praktischen Guides für bessere Recherche, Vergleiche und ein besseres Verständnis jedes Schritts Ihres Kaufs.',
  'hero.trust': 'Organisierte Ressourcen • Aktuelle Guides • Mehrsprachiger Support',
  'search.placeholder': 'Produkte, Verkäufer, Kategorien oder Keywords suchen...',
  'search.popular': 'Beliebt:',
  'categories.title': 'Beliebte Kategorien erkunden',
  'categories.subtitle': 'Finden Sie organisierte Ressourcen nach Kategorie für schnellere und einfachere Recherche.',
  'categories.shoes': 'Schuhe',
  'categories.hoodies': 'Hoodies/Pullover',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Jacken',
  'categories.pants': 'Hosen/Shorts',
  'categories.headwear': 'Kopfbedeckung',
  'categories.sets': 'Sets',
  'categories.underwear': 'Unterwäsche',
  'categories.jersey': 'Trikots',
  'categories.accessories': 'Accessoires',
  'categories.bags': 'Taschen',
  'categories.belts': 'Gürtel',
  'categories.perfumes': 'Parfums',
  'categories.other': 'Sonstiges',
  'spreadsheet.title': 'Warum ein CSSBuy Spreadsheet verwenden?',
  'spreadsheet.desc': 'Ein gut organisiertes Spreadsheet kann Ihnen helfen, Produkte und Verkäufer einfacher zu finden, Informationen zu vergleichen und die Zeit für die Recherche verschiedener Quellen zu reduzieren.',
  'spreadsheet.faster': 'Schnellere Suche',
  'spreadsheet.fasterDesc': 'Finden Sie Ressourcen nach Produkt, Kategorie oder Verkäufer.',
  'spreadsheet.organized': 'Alles organisiert',
  'spreadsheet.organizedDesc': 'Sehen Sie Informationen in einer einfachen, leicht navigierbaren Struktur.',
  'spreadsheet.context': 'Mehr Kontext',
  'spreadsheet.contextDesc': 'Kombinieren Sie Spreadsheets mit QC-Guides, Verkäufern und Versand.',
  'guides.title': 'Alles was Sie vor dem Kauf wissen müssen',
  'guides.desc': 'Lernen Sie, wie Sie Produkte recherchieren, Verkäufer bewerten, QC-Fotos analysieren und verschiedene Versandoptionen berücksichtigen.',
  'guides.howToUse': 'CSSBuy Spreadsheet verwenden',
  'guides.evaluateSellers': 'Verkäufer bewerten',
  'guides.qcPhotos': 'QC-Fotos analysieren',
  'guides.shipping': 'Versand verstehen',
  'safety.title': 'Sicherheit geht vor',
  'safety.desc': 'Überprüfen Sie immer Links, Quellen und Informationen vor dem Kauf. Teilen Sie niemals Ihr Passwort oder persönliche Daten mit unbekannten Seiten. Seien Sie vorsichtig bei Angeboten, Coupons und unverifizierten Verkäufern.',
  'commercial.title': 'CSSBuy recherchieren? Starten Sie mit den richtigen Informationen.',
  'commercial.review': 'CSSBuy Bewertung',
  'commercial.shipping': 'CSSBuy Versandkosten',
  'commercial.coupon': 'CSSBuy Coupon',
  'commercial.discount': 'CSSBuy Rabattcode',
  'commercial.warehouse': 'CSSBuy Lager',
  'commercial.legit': 'Ist CSSBuy seriös?',
  'finalCta.title': 'Bereit, Ihre Recherche zu starten?',
  'finalCta.desc': 'Erkunden Sie das CSSBuy Spreadsheet, finden Sie relevante Ressourcen und setzen Sie Ihre Einkaufsreise mit besser organisierten Informationen fort.',
  'articles.title': 'Neueste Guides und Artikel',
  'articles.subtitle': 'Origineller, vertiefter Inhalt, um Ihnen bei besseren Entscheidungen zu helfen.',
  'article.cssbuyGuide.title': 'CSSBuy Spreadsheet: Kompletter Guide für Anfänger',
  'article.cssbuyGuide.excerpt': 'Lernen Sie, CSSBuy Spreadsheets zu verwenden, um Produkte zu finden, Verkäufer zu vergleichen und fundierte Kaufentscheidungen zu treffen. Dieser umfassende Guide deckt alles von Grundlagen bis hin zu fortgeschrittenen Tipps ab.',
  'article.cssbuyGuide.readTime': '8 Min. Lesedauer',
  'article.cssbuyGuide.date': 'August 2026',
  'breadcrumb.home': 'Startseite',
  'breadcrumb.articles': 'Artikel',
  'dropdown.allCategories': 'Alle Kategorien',
  'dropdown.shoes': 'Schuhe',
  'dropdown.hoodies': 'Hoodies/Pullover',
  'dropdown.tshirts': 'T-Shirts',
  'dropdown.jackets': 'Jacken',
  'dropdown.pants': 'Hosen/Shorts',
  'dropdown.headwear': 'Kopfbedeckung',
  'dropdown.sets': 'Sets',
  'dropdown.underwear': 'Unterwäsche',
  'dropdown.jersey': 'Trikots',
  'dropdown.accessories': 'Accessoires',
  'dropdown.bags': 'Taschen',
  'dropdown.belts': 'Gürtel',
  'dropdown.perfumes': 'Parfums',
  'dropdown.other': 'Sonstiges',
};

export default common;